import React from 'react';
import GameAdminList from './GameAdminList';

function GamesAdmin(props) {

    const { games } = props;

    return <div>
        {games ?
            <GameAdminList
                games={games}
            />
            : 'loading...'
        }
    </div>;
}

export default GamesAdmin